import { MaintenancePriority } from '@/services/maintenances-service/maintenances-service.types';
import styles from './priority-chip.module.scss';

interface PriorityChipProps {
  priority: MaintenancePriority;
}

export default function PriorityChip({ priority }: PriorityChipProps) {
  const normalizedPriority = priority.toLowerCase() as MaintenancePriority;

  return (
    <div className={`${styles.priority} ${styles[`priority-${normalizedPriority}`]}`}>
      {normalizedPriority.charAt(0).toUpperCase() + normalizedPriority.slice(1)}
    </div>
  );
}
